module.exports = __webpack_public_path__ + "static/media/sell_take_order_teach_2.d63b7a18.jpg";